import moment from 'moment'
export default function CubeTimeDimensionRange(plantTimeZone: any) {
	const ranges: any = [
		{
			label: 'Last 12 hours',
			value: [
				moment.tz(plantTimeZone).subtract(12, 'hours').format('YYYY-MM-DDTHH:mm:ss.000'),
				moment.tz(plantTimeZone).format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '12', unit: 'hours' }
		},

		{
			label: 'Last 24 hours',
			value: [
				moment.tz(plantTimeZone).subtract(24, 'hours').format('YYYY-MM-DDTHH:mm:ss.000'),
				moment.tz(plantTimeZone).format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '24', unit: 'hours' }
		},

		{
			label: 'Last 2 days',
			value: [
				moment.tz(plantTimeZone).subtract(48, 'hours').format('YYYY-MM-DDTHH:mm:ss.000'),
				moment.tz(plantTimeZone).format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '48', unit: 'hours' }
		},
		{
			label: 'Last 7 days',
			value: [
				moment
					.tz(plantTimeZone)
					.startOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.subtract(6, 'days')
					.format('YYYY-MM-DDTHH:mm:ss.000'),
				moment
					.tz(plantTimeZone)
					.endOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '7', unit: 'days' }
		},
		//props.plant?.plant_timezone
		{
			label: 'Last 2 weeks',
			value: [
				moment
					.tz(plantTimeZone)
					.startOf('day')
					//subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.subtract(13, 'days')
					.format('YYYY-MM-DDTHH:mm:ss.000'),
				moment
					.tz(plantTimeZone)
					.endOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '14', unit: 'days' }
		},
		{
			label: 'Last 30 days',
			value: [
				moment
					.tz(plantTimeZone)
					.startOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.subtract(29, 'days')
					.format('YYYY-MM-DDTHH:mm:ss.000'),
				moment
					.tz(plantTimeZone)
					.endOf('day')
					//subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '30', unit: 'days' }
		},
		{
			label: 'Last 90 days',
			value: [
				moment
					.tz(plantTimeZone)
					.startOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.subtract(89, 'days')
					.format('YYYY-MM-DDTHH:mm:ss.000'),
				moment
					.tz(plantTimeZone)
					.endOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '90', unit: 'days' }
		},
		{
			label: 'Last 6 months',
			value: [
				moment
					.tz(plantTimeZone)
					.startOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.subtract(6, 'months')
					.format('YYYY-MM-DDTHH:mm:ss.000'),
				moment
					.tz(plantTimeZone)
					.endOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '6', unit: 'months' }
		},
		{
			label: 'Last 1 year',
			value: [
				moment
					.tz(plantTimeZone)
					.startOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.subtract(1, 'years')
					.format('YYYY-MM-DDTHH:mm:ss.000'),
				moment
					.tz(plantTimeZone)
					.endOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.format('YYYY-MM-DDTHH:mm:ss.000')
			],
			difference: { value: '1', unit: 'years' },

			placement: 'left'
		},
		{
			label: 'Last 2 years',
			value: [
				moment
					.tz(plantTimeZone)
					.startOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.subtract(2, 'years')
					.format('YYYY-MM-DDTHH:mm:ss.000'),
				moment
					.tz(plantTimeZone)
					.endOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '2', unit: 'years' }
		},
		{
			label: 'Last 3 years',
			value: [
				moment
					.tz(plantTimeZone)
					.startOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.subtract(3, 'years')
					.format('YYYY-MM-DDTHH:mm:ss.000'),
				moment
					.tz(plantTimeZone)
					.endOf('day')
					//.subtract(moment().tz(planttimezone)?.utcOffset(), 'minutes')
					.format('YYYY-MM-DDTHH:mm:ss.000')
			],
			placement: 'left',
			difference: { value: '3', unit: 'years' }
		}
	]

	return ranges;
}
